import {DefaultComponents} from 'components/QueryResult';

const {loading: Spinner} = DefaultComponents;

export default Spinner;
